import dayjs from 'dayjs'
import CustomParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'
import { omit } from 'lodash'

import { IDriver } from '@/steps/MotorTrade/Drivers/Driver'
import { existingTradePlatesStore } from '@/store/MotorTradeFormStore'

dayjs.extend(utc)
dayjs.extend(CustomParseFormat)

export const MotorTradeGuidConvert = (formData: any) => {
  let editedData
  editedData = omit(formData, 'tradePlateNumbers')
  // STEP 1

  const setExistingTrades =
    existingTradePlatesStore.getState().setExistingTradePlates

  editedData.proposershowAddress = true

  // STEP 2
  editedData.tradingPremises = formData?.tradingPremises?.map(
    (premise: {
      tradingPremiseTypeId: number
      tradingPremisePostcode: string
      tradingPremiseHouseNo: string
      tradingPremiseStreet: string
      tradingPremiseTown: string
      tradingPremiseCity: string
      tradingPremiseCounty: string
      tradingPremiseYearsTrading: number
      tradingPremiseIsSharedWorksite: boolean
    }) => {
      return {
        ...premise,
        showAddress: true,
      }
    }
  )

  // STEP 6
  editedData.drivers =
    formData?.drivers?.map((driver: IDriver) => {
      return {
        ...driver,
        showAddress: true,
      }
    }) || []

  // STEP 7
  editedData.tradePlateNumbers =
    formData?.tradePlateNumbers?.map((plate: string) => {
      return {
        plateNumber: plate,
      }
    }) || []

  if (formData?.tradePlateNumbers && formData?.tradePlateNumbers?.length > 0) {
    setExistingTrades(true)
  }

  // STEP SUMMARY

  const editedTime = dayjs(
    editedData?.proposerPolicyStartDate,
    'YYYY-MM-DDTHH:mm'
  ).format('HH:mm')

  editedData.proposerPolicyStartTime = editedTime

  return editedData
}
